<template>
	<div ref="popupContainer">
		<vs-popup
			:active.sync="showConfirmationPopup"
			title="Êtes-vous sûr de vouloir valider la supression du document ?"
		>
			<div class="vx-row" style="z-index: 100 !important">
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="accept()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="decline()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<vs-popup
			:title="societyName + ', Contrat N°' + contractId + ' : ' + productName"
			:active.sync="showDocPopup"
		>
			<ShareLinkPopup
				v-model="showDocPopup"
				:apiUrl="apiUrl"
				:society_id="societyId"
				:mission_id="missionId"
				:task_id="taskId"
				:contract_id="contractId"
				@open-confirmation="confirmation(arguments)"
				ref="shareLink"
			/>
		</vs-popup>
		<vs-popup
			:active.sync="showLinkEditPopup"
			title="Modification d'un Netlink"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap">
					<label for="" class="vs-select--label">Lien acheté</label>
					<div class="flex">
						<vs-input
							class="w-full"
							placeholder="Lien acheté"
							v-model="modifiedNetlink.url_bought"
							:style="styleValidator('url_bought')"
							@change="validateOne(modifiedNetlink.url_bought, 'url_bought')"
						/>
						<vx-tooltip
							v-if="
								validators['url_bought'] &&
								validators['url_bought'].errText !== ''
							"
							:text="errText('url_bought')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap">
					<label for="" class="vs-select--label">Landing page</label>
					<div class="flex">
						<vs-input
							class="w-full"
							placeholder="Landing page"
							v-model="modifiedNetlink.landing_page"
							:style="styleValidator('landing_page')"
							@change="
								validateOne(modifiedNetlink.landing_page, 'landing_page')
							"
						/>
						<vx-tooltip
							v-if="
								validators['landing_page'] &&
								validators['landing_page'].errText !== ''
							"
							:text="errText('landing_page')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap">
					<label for="" class="vs-select--label">Statut</label>
					<div class="flex">
						<vs-select
							autocomplete
							v-model="modifiedNetlink.status"
							class="w-full select-medium mr-2"
							placeholder="Statut"
							:style="styleValidator('status')"
							@change="validateOne(modifiedNetlink.status, 'status')"
						>
							<vs-select-item
								:key="index"
								:value="item.value"
								:text="item.text"
								v-for="(item, index) in netlinkStatus"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="validators['status'] && validators['status'].errText !== ''"
							:text="errText('status')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
			</div>
			<div class="vx-row mt-2">
				<div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap">
					<label for="" class="vs-select--label">Type ancre</label>
					<div class="flex">
						<vs-select
							autocomplete
							v-model="modifiedNetlink.anchor_type"
							class="w-full select-medium mr-2"
							placeholder="Type ancre"
							:style="styleValidator('anchor_type')"
							@change="validateOne(modifiedNetlink.anchor_type, 'anchor_type')"
						>
							<vs-select-item
								:key="index"
								:value="item.value"
								:text="item.text"
								v-for="(item, index) in anchorTypes"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['anchor_type'] &&
								validators['anchor_type'].errText !== ''
							"
							:text="errText('anchor_type')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap">
					<label for="" class="vs-select--label">Type lien</label>
					<div class="flex">
						<vs-select
							autocomplete
							v-model="modifiedNetlink.link_type"
							class="w-full select-medium mr-2"
							placeholder="Type lien"
							:style="styleValidator('link_type')"
							@change="validateOne(modifiedNetlink.link_type, 'link_type')"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.name"
								v-for="(item, index) in netlink_types"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['link_type'] &&
								validators['link_type'].errText !== ''
							"
							:text="errText('link_type')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<div
					v-if="modifiedNetlink"
					class="vx-col sm:w-1/3 w-full"
					style="white-space: nowrap"
				>
					<label for="" class="vs-select--label">Prix</label>
					<div class="flex">
						<vs-input
							class="w-full"
							v-model="modifiedNetlink.price"
							:style="styleValidator('price')"
							@change="validateOne(modifiedNetlink.price, 'price')"
						/>
						<vx-tooltip
							v-if="validators['price'] && validators['price'].errText !== ''"
							:text="errText('price')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<div
					v-if="isRecurringLink(modifiedNetlink.link_type)"
					class="vx-col sm:w-1/3 w-full"
					style="white-space: nowrap !important"
				>
					<label for="" class="vs-select--label">Renouvellement</label>
					<div class="flex">
						<vs-select
							autocomplete
							v-model="modifiedNetlink.renew_duration"
							class="w-full select-medium mr-2"
							:style="styleValidator('renew_duration')"
							@change="
								validateOne(modifiedNetlink.renew_duration, 'renew_duration')
							"
						>
							<vs-select-item
								:key="index"
								:value="item.value"
								:text="item.text"
								v-for="(item, index) in renewDurations"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['renew_duration'] &&
								validators['renew_duration'].errText !== ''
							"
							:text="errText('renew_duration')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<div class="vx-col sm:w-1/3 w-full">
					<vs-button color="primary" class="mt-2" @click="saveModifiedNetlink()"
						>Enregistrer Netlink</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<div class="mb-5 text-center" v-if="isLoading">
			<circular-loader />
		</div>
		<vs-table
			v-else
			max-items="100"
			:data="$props.contracts"
			:key="refreshKey"
			style="height: 100%"
			id="tb"
			noDataText="Aucune tâche restante"
		>
			<template slot="thead">
				<vs-th style="width: 40px; pointer-events: auto">
					<div
						@click.stop="toggleAllExpand()"
						class="expand-icon-wrapper"
						style="
							cursor: pointer !important;
							display: flex;
							justify-content: center;
							pointer-events: auto;
							padding: 5px;
							user-select: none;
						"
						:style="{
							transform: allExpanded ? 'rotate(0deg)' : 'rotate(0deg)',
						}"
					>
						<vs-icon
							:icon="
								allExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
							"
							size="small"
							style="pointer-events: none"
						/>
					</div>
				</vs-th>
				<vs-th
					sort-key="contract_id"
					class="th-sticky pdl0"
					style="pointer-events: auto"
					>N°Contrat
				</vs-th>
				<vs-th
					sort-key="society_name"
					class="th-sticky pdl0"
					style="pointer-events: auto"
					>Client</vs-th
				>
				<vs-th
					sort-key="type_name"
					class="th-sticky"
					style="pointer-events: auto"
					><span class="w-full text-center">Type</span></vs-th
				>
				<vs-th
					sort-key="lead_account_manager_name"
					class="th-sticky pdl0"
					style="pointer-events: auto"
					><span class="w-full text-center">Commercial</span></vs-th
				>
				<vs-th
					sort-key="lead_account_manager_name"
					class="th-sticky pdl0"
					style="pointer-events: auto"
					><span class="w-full text-center">Consultant Lead</span></vs-th
				>
				<vs-th
					sort-key="contract_status"
					class="th-sticky"
					style="pointer-events: auto"
					><span class="w-full text-center">Statut</span></vs-th
				>
				<vs-th
					sort-key="tasks_done"
					class="th-sticky"
					style="pointer-events: auto"
					><span class="w-full text-center">Tâches restantes</span></vs-th
				>
				<vs-th
					sort-key="tasks_done"
					class="th-sticky"
					style="pointer-events: auto"
					><span class="w-full text-center">Alerte</span></vs-th
				>

				<!--<vs-th class="th-sticky"><span class="w-full text-center">Budget Max Total</span></vs-th>-->
				<vs-th
					v-if="activeUser.role != '2' && activeUser.type != '7'"
					sort-key="total_spent_budget"
					class="th-sticky"
					style="pointer-events: auto"
					><span class="w-full text-right">Achats</span></vs-th
				>
				<vs-th
					sort-key="google_ads_cost"
					class="th-sticky"
					style="pointer-events: auto"
				></vs-th>
				<!--<vs-th class="th-sticky"><span class="w-full text-center">Budget restant</span></vs-th>-->
				<vs-th
					v-if="activeUser.role != '2' && activeUser.type != '7'"
					class="th-sticky"
					style="pointer-events: auto"
				>
				</vs-th>
			</template>

			<template slot-scope="{ data }">
				<tbody v-for="(contract, index) in data" :key="'row-' + index">
					<vs-tr
						class="getWidth"
						:style="getLineColor(contract.total_tasks, contract.tasks_done)"
						ref="switch"
						@click="toggleExpandIfNotInteractive($event, index)"
						style="cursor: pointer"
					>
						<!--For just calculating the number of rows-->
						<div v-show="false">
							{{ setRowNum(data.length) }}
						</div>
						<!--For just calculating the number of rows-->
						<vs-td style="width: 40px; text-align: center">
							<div
								@click.stop="toggleExpand(index)"
								class="expand-icon-wrapper"
								style="
									cursor: pointer !important;
									display: flex;
									justify-content: center;
									padding: 5px;
									user-select: none;
								"
								:style="{
									transform: expandedRows[index]
										? 'rotate(0deg)'
										: 'rotate(0deg)',
								}"
							>
								<vs-icon
									:icon="
										expandedRows[index]
											? 'keyboard_arrow_down'
											: 'keyboard_arrow_right'
									"
									size="small"
									style="pointer-events: none"
								/>
							</div>
						</vs-td>
						<vs-td :data="data[index].id"
							><span
								@click.stop="event.stopPropagation()"
								@click="displayContractPopup(contract.contract_id)"
								class="hvr-underline hvr-underline-out"
								>{{ contract.contract_id }}</span
							></vs-td
						>
						<vs-td :data="data[index].society_name"
							><span
								class="hvr-underline"
								@click.stop="event.stopPropagation()"
								@click="displaySocietyPopup(contract.society_id)"
								><strong>{{ data[index].society_name }}</strong></span
							></vs-td
						>
						<vs-td :data="data[index].type_name" class="text-center pdl0">{{
							data[index].type_name
						}}</vs-td>
						<vs-td :data="data[index].commercial_name" class="text-center pdl0">
							<div @click.stop="event.stopPropagation()">
								<avatar-message-chip
									:key="index"
									:user="{
										users_id: data[index].commercial_id,
										name: data[index].commercial_name,
										is_lead: true,
									}"
									:contract="{
										id: contract.contract_id,
										society_id: contract.society_id,
									}"
								/>
							</div>
						</vs-td>
						<vs-td
							:data="data[index].lead_account_manager_name"
							class="text-center pdl0"
						>
							<div @click.stop="event.stopPropagation()">
								<avatar-message-chip
									:key="index"
									:user="{
										users_id: data[index].lead_account_manager_id,
										name: data[index].lead_account_manager_name,
										is_lead: true,
									}"
									:contract="{
										id: contract.contract_id,
										society_id: contract.society_id,
									}"
								/>
							</div>
						</vs-td>
						<vs-td
							:data="contract.contract_status"
							style="padding-left: 10px; width: 100px"
						>
							<vs-chip
								style="width: 80px; margin-top: 2px"
								:color="getContractStatusColor(contract.contract_status)"
							>
								{{ getContractStatus(contract.contract_status) }}
							</vs-chip>
						</vs-td>
						<vs-td :data="data[index].id" class="text-center pdl0">{{
							data[index].tasks_done + " / " + contract.total_tasks
						}}</vs-td>

						<vs-td :data="data[index].id" class="text-center pdl0"
							><vs-icon
								v-if="data[index].is_budget_flexible_not_dispatched"
								icon="warning"
								size="small"
								class="cursor-pointer"
								color="warning"
								@click.stop="
									openFlexiblePopup(
										contract.contract_id,
										contract.lead_account_manager_id
									)
								"
						/></vs-td>

						<!--<vs-td :data="data[index].id" class="text-center">{{ contract.total_max_budget == 0 ? "" : String(contract.total_max_budget) + "€" }}</vs-td>-->
						<vs-td
							:data="data[index].id"
							v-if="activeUser.role != '2' && activeUser.type != '7'"
							class="text-right pdl0"
							style="padding-right: 11px"
							><span
								@click="displayBudgetPopup(contract)"
								class="hvr-underline hvr-underline-out"
								>{{
									contract.total_spent_budget
										? convertNumberToFrenchCurrency(contract.total_spent_budget)
										: ""
								}}</span
							></vs-td
						>
						<vs-td
							:data="contract.type_id"
							class="text-right cursor-pointer"
							style="padding-right: 13px"
							:key="googleAdsKey"
						>
							<div v-if="contract.type_id == 2">
								<google-ads-cost-view-chip
									v-if="!isLoadingGoogleAds"
									:google_ads_mcc="contract.google_ads_mcc"
									:type_id="contract.type_id"
									:googleAds="googleAds"
									:societyId="contract.society_id"
									:date="new Date()"
									:limit="1"
									:additonalText="' (En cours)'"
								/>
								<div
									v-else
									:data="contract.google_ads"
									class="text-right"
									style="padding-right: 13px"
								>
									<circular-loader />
								</div>
							</div>
						</vs-td>

						<!--<vs-td :data="data[index].id" class="text-center" :style="setSoldeColor(contract.solde)">{{ setSolde(contract.solde) }}</vs-td>-->
						<vs-td
							:data="data[index].id"
							v-if="activeUser.role != '2' && activeUser.type != '7'"
						>
							<div
								style="display: flex; justify-content: space-evenly"
								@click.stop="event.stopPropagation()"
							>
								<!--<vs-button @click="displayLinkPopup(contract.contract_id, contract.society_name)" style="width: 180px !important; white-space: nowrap;">Liens en attente <span v-if="contract.waiting_netlink_count > 0" style="border-radius: 5px; background-color: rgb(140, 23, 164); color: white;" class="px-2 ml-1">{{ contract.waiting_netlink_count }}</span></vs-button>-->
								<!-- <vx-tooltip text="Message Commercial" position="top">
								<vs-button
									@click="displayNotepadPopup(contract)"
									icon-pack="feather"
									icon="icon-message-square"
								></vs-button>
							</vx-tooltip> -->
								<vx-tooltip text="Historique des tâches" position="top">
									<vs-button
										@click="
											displayHistoryPopup(
												contract.contract_id,
												contract.society_id,
												contract.society_name
											)
										"
										icon-pack="feather"
										icon="icon-list"
									></vs-button>
								</vx-tooltip>
								<vx-tooltip text="Keywords" position="top">
									<vs-button
										@click="jumpToKeyword(contract.society_id)"
										icon-pack="feather"
										icon="icon-trending-up"
									></vs-button>
								</vx-tooltip>
								<!-- <vx-tooltip
								text="Ajouter un achat"
								position="top"
							>
								<vs-button @click="displayNewPurchasePopup(contract)" icon-pack="feather" icon="icon-shopping-cart"></vs-button>
							</vx-tooltip> -->
								<vx-tooltip text="Ajouter une commande" position="top">
									<vs-button
										@click="displayNewCommandePopup(contract)"
										icon-pack="feather"
										icon="icon-briefcase"
									></vs-button>
								</vx-tooltip>
							</div>
						</vs-td>
					</vs-tr>
					<tr
						v-if="expandedRows[index]"
						:key="'expand-' + index"
						class="expand-row"
					>
						<td :colspan="12" style="padding: 0">
							<div class="vx-row w-full" style="padding: 0 10px 0 10px">
								<vs-table
									:data="contract.missions_list"
									class="w-full"
									:key="tableRefreshKey"
								>
									<template slot="thead">
										<vs-th>#</vs-th>
										<vs-th>Prestation</vs-th>
										<vs-th
											><span class="w-full text-center"
												>Commentaire</span
											></vs-th
										>
										<vs-th
											><span class="w-full text-center">Consultant</span></vs-th
										>
										<vs-th
											><span class="w-full text-center">Reccurence</span></vs-th
										>
										<vs-th style="width: 170px !important"
											><span class="w-full text-center"
												>Etat de la tâche</span
											></vs-th
										>
										<vs-th
											><span class="w-full text-center">Période</span></vs-th
										>
										<!--<vs-th><span class="w-full text-center">Budget max</span></vs-th>-->
										<vs-th>
											<div
												class="w-full text-center"
												style="pointer-events: auto"
											>
												<vx-tooltip
													text="Nombre de points par mois avec le client"
													position="top"
												>
													<vs-icon icon-pack="feather" icon="icon-users" />
												</vx-tooltip>
											</div>
										</vs-th>
										<vs-th>
											<div
												class="w-full text-center"
												style="pointer-events: auto"
											>
												<vx-tooltip
													text="Temps maxi à passer par mois"
													position="top"
												>
													<vs-icon icon-pack="feather" icon="icon-clock" />
												</vx-tooltip>
											</div>
										</vs-th>
										<!--<vs-th>
										<div
											class="w-full text-center"
											style="pointer-events: auto"
										>
											<vx-tooltip text="Documents" position="top">
												<vs-icon icon-pack="feather" icon="icon-file" />
											</vx-tooltip>
										</div>
									</vs-th> -->
										<vs-th>
											<div
												class="w-full text-center"
												style="pointer-events: auto"
											>
												<vx-tooltip text="Backlinks" position="top">
													<vs-icon icon-pack="feather" icon="icon-link" />
												</vx-tooltip>
											</div>
										</vs-th>
										<!-- <vs-th v-if="activeUser.role != '2' && activeUser.type != '7'"><div class="w-full text-center">Documents</div></vs-th> -->
										<vs-th class="text-right">Achat HT</vs-th>
										<vs-th class="text-right">Budget Maxi</vs-th>
										<vs-th class="text-right">Ads</vs-th>
										<vs-th class="text-right">Action</vs-th>
									</template>

									<template slot-scope="{ data }">
										<vs-tr
											:data="item"
											:key="itemIndex"
											v-for="(item, itemIndex) in data"
											style="background: white"
										>
											<vs-td class="text-center">{{
												item.product_number
											}}</vs-td>
											<vs-td class="text-left">{{ item.product_name }}</vs-td>
											<vs-td
												class="text-center pdl0"
												style="width: 400px !important"
												>{{ item.task_commentary }}</vs-td
											>
											<vs-td class="text-center pdl0">
												<div
													v-if="item.task_flexible"
													class="vx-row center-content"
													style="margin: 0; justify-content: center"
												>
													<div
														class="flex center"
														:key="index"
														@click.stop="event.stopPropagation()"
													>
														<avatar-message-chip
															:key="index"
															:user="{
																users_id: item.task_user_id,
																name: item.task_user_name,
															}"
															:contract="{
																id: contract.contract_id,
																society_id: contract.society_id,
															}"
														/>
														<!-- <vx-tooltip
														:text="item.task_user_name"
														position="top"
													>
														<vs-avatar
															style="border: 1px solid"
															badge-color="rgb(140, 23, 164)"
															:text="item.task_user_name"
															:src="getCollaboratorAvatar(item.task_user_id)"
														/>
													</vx-tooltip> -->
													</div>
												</div>
												<div
													v-else
													class="vx-row center-content"
													style="margin: 0; justify-content: center"
												>
													<div
														class="flex center"
														v-for="(
															account_manager_avatar, index
														) in item.account_manager_ids"
														:key="index"
													>
														<avatar-message-chip
															:key="index"
															:user="{
																users_id: account_manager_avatar,
																name: item.account_manager_names[index],
															}"
															:contract="{
																id: contract.contract_id,
																society_id: contract.society_id,
															}"
														/>
														<!-- <vx-tooltip
														:text="item.account_manager_names[index]"
														position="top"
													>
														<vs-avatar
															style="border: 1px solid"
															badge-color="rgb(140, 23, 164)"
															:text="item.account_manager_names[index]"
															:src="
																getCollaboratorAvatar(account_manager_avatar)
															"
														/>
													</vx-tooltip> -->
													</div>
												</div>
											</vs-td>
											<vs-td class="text-center pdl0">{{
												getPurchaseFrequency(item.mission_recurrence)
											}}</vs-td>
											<vs-td class="text-center">
												<Slider
													v-if="
														item.account_manager_ids.includes(
															String(activeUser.id)
														) || activeUser.type != '7'
													"
													:id1="item.task_id + 'offcard'"
													:id2="item.task_id + 'nullcard'"
													:id3="item.task_id + 'oncard'"
													:value="item.task_archived"
													styleSld="font-size: 10px; background-color: rgba(224, 224, 224, 0.78);width: 165px;"
													styleOp1="color: black; background-color: #FF0000; width:55px; padding: 5px 10px;"
													styleOp2="color: black; background-color: #FFA800; width:55px; padding: 5px 10px;"
													styleOp3="color: black; background-color: #28C76F; width:55px; padding: 5px 10px;"
													styleDefault="color: black;"
													option1="Annulé"
													option2="À faire"
													option3="Fait"
													@btn-selected="updateTask(item, $event, contract)"
												/>
												<vs-chip
													v-else
													style="width: 80px; margin-top: 2px"
													:color="getTaskStatusColor(item.task_archived)"
												>
													{{ getTaskStatus(item.task_archived) }}
												</vs-chip>
											</vs-td>

											<vs-td class="text-center pdl0">{{
												getDate(item.task_date)
											}}</vs-td>
											<!--<vs-td class="text-center">{{item.budget_max ? item.budget_max + "€" : ""}}</vs-td>-->
											<vs-td class="text-center pdl0">{{
												item.meeting_number
											}}</vs-td>
											<vs-td class="text-center pdl0">{{
												item.time_limit
											}}</vs-td>

											<!--<vs-td
											v-if="activeUser.role != '2' && activeUser.type != '7'"
											class="text-left"
										>
											<div style="display: flex; justify-content: center">
												<vx-tooltip text="Ajouter un lien" position="top">
													<vs-button
														size="large"
														color="primary"
														type="flat"
														icon-pack="feather"
														icon="icon-file-plus"
														@click="displayDocPopup(contract, item)"
													></vs-button>
												</vx-tooltip>
											</div>
										</vs-td> -->

											<vs-td class="text-left">
												<div
													style="display: flex; justify-content: center"
													v-if="
														item.product_sub_category == 7 ||
														item.product_id == 136
													"
												>
													<vx-tooltip text="Backlinks" position="top">
														<vs-button
															size="large"
															color="primary"
															type="flat"
															icon-pack="feather"
															icon="icon-link"
															@click="displayBacklinksPopup(contract, item)"
														></vs-button>
													</vx-tooltip>
												</div>
											</vs-td>
											<vs-td
												class="text-right pdl0"
												style="padding-right: 12px"
												>{{
													item.mission_purchases_period_total
														? convertNumberToFrenchCurrency(
																item.mission_purchases_period_total
														  )
														: ""
												}}</vs-td
											>
											<vs-td
												class="text-right pdl0"
												style="padding-right: 12px"
												>{{
													convertNumberToFrenchCurrency(item.budget_max)
												}}</vs-td
											>
											<vs-td
												class="text-right pdl0 cursor-pointer"
												style="padding-right: 12px"
											>
												<div v-if="contract.type_id == 2">
													<div v-if="!isLoadingGoogleAds">
														<google-ads-cost-view-chip
															:google_ads_mcc="contract.google_ads_mcc"
															:type_id="contract.type_id"
															:googleAds="googleAds"
															:societyId="contract.society_id"
															:date="item.task_date"
														/>
													</div>
													<div
														v-else
														class="text-right"
														style="padding-right: 12px"
													>
														<circular-loader />
													</div>
												</div>
											</vs-td>

											<vs-td
												class="text-right pdl0"
												style="padding-right: 12px"
											>
												<div class="flex space-between space-x-2">
													<vx-tooltip text="Ajouter un achat" position="top">
														<vs-button
															@click="
																displayNewPurchasePopup(
																	contract,
																	item.mission_id
																)
															"
															icon-pack="feather"
															icon="icon-shopping-cart"
														></vs-button>
													</vx-tooltip>
													<vx-tooltip
														text="Commentaires du facturation"
														position="top"
													>
														<vs-button
															class="ml-2"
															@click="displayTaskComment(contract, item)"
															icon-pack="feather"
															icon="icon-message-square"
														></vs-button>
													</vx-tooltip></div
											></vs-td>
										</vs-tr>
										<vs-tr
											v-if="contract.is_budget_flexible_not_dispatched"
											style="width: 100%"
											><vs-td
												colspan="14"
												style="
													background-color: #fff3cd;
													padding: 15px;
													width: 100% !important;
												"
											>
												<div
													style="
														width: 100%;
														display: flex;
														align-items: center;
													"
												>
													<vs-icon
														icon="warning"
														size="small"
														class="cursor-pointer"
														color="warning"
														@click.stop="
															openFlexiblePopup(
																contract.contract_id,
																contract.lead_account_manager_id
															)
														"
														style="margin-right: 8px; flex-shrink: 0"
													/>
													<span>
														<strong>Attention:</strong> Les autres tâches ne
														sont pas affichées, le budget flexible n'est pas
														disponible pour cette période.
													</span>
												</div>
											</vs-td>
										</vs-tr>

										<!-- a -->
									</template>
								</vs-table>

								<CommandeTable
									:fromGestion="true"
									:nameCommande="true"
									v-if="contract.orders_list.length > 0"
									:orders="contract.orders_list"
									:contract="contract"
									:readOnly="false"
									:fromAllOrders="false"
									ref="orderTable"
									style="width: calc(100% + 20px)"
									:key="refreshOrderTableKey"
								/>
							</div>
						</td>
					</tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import Vue from "vue";
import store from "@/store/store";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin.js";
import Netlink from "@/entities/Netlink";
import BudgetDetailPopup from "@/components/popups/BudgetDetailPopup";
import ContractInfoPopup from "@/components/popups/ContractInfoPopup";
import HistoricalPurchasesPopup from "@/components/popups/HistoricalPurchasesPopup";
import NewCommandePopup from "@/components/popups/NewCommandePopup";
import LinkPopup from "@/components/popups/NetlinkInfoPopup";
import SocietyInfoPopup from "@/components/popups/SocietyInfoPopup";
import ShareLinkPopup from "@/components/popups/ShareLinkPopup";
import TaskHistoryPopup from "@/components/popups/TaskHistoryPopup";
import Slider from "@/components/widgets/SliderWith3btn";
import Validator from "@/entities/Validator";
import VueCookies from "vue-cookies";
import NotepadPopup from "@/components/popups/NotepadPopup.vue";
import CommandeTable from "@/components/tables/CommandeTable";
import AvatarMessageChip from "../chips/AvatarMessageChip.vue";
import CircularLoader from "../widgets/loader/CircularLoader.vue";
import GoogleAdsCostViewChip from "../chips/GoogleAdsCostViewChip.vue";
import TaskFacturationCommentPopup from "../popups/TaskFacturationCommentPopup.vue";
import Society from "../../entities/Society";
import BacklinksContractPopup from "../popups/BacklinksContractPopup.vue";

// import XLSX from "xlsx";

export default {
	name: "GestionConsultantsTable",
	props: {
		isLoading: Boolean,
		contracts: Array,
		selectedDate: String,
		refreshKey: Number,
	},
	mixins: [dbFieldConvertor, utilsMixin],
	components: {
		Slider,
		CommandeTable,
		ShareLinkPopup,
		AvatarMessageChip,
		CircularLoader,
		GoogleAdsCostViewChip,
		TaskFacturationCommentPopup,
	},
	computed: {
		filterCardHeight: () => {
			return store.state.filterCardHeight;
		},
		isFilterDown: () => {
			return store.state.isFilterDown;
		},
		horizentalNavBarHeight: () => {
			return store.state.horizentalNavBarHeight;
		},
		windowHeigth: () => {
			return store.state.windowHeigth;
		},
		tableHeight: () => {
			return store.state.tableHeight;
		},
		activeUser() {
			return VueCookies.get("userInfo");
		},
		showNewCommandePopup: () => {
			return store.state.showAddNewCommandePopup;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		allContractsWithContractsUsers: () => {
			return store.state.contracts_contracts_users;
		},
		all_orders: () => {
			return store.state.allOrderList;
		},
		netlink_types: () => {
			return store.state.netlink_types;
		},
		products_categories: () => {
			return store.state.products_categories.map((row) => row.name);
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		},
		societies: () => {
			return store.state.societies;
		},
		tasks: () => {
			return store.state.tasks;
		},
	},
	data() {
		return {
			showNum: true,
			rowNum: 0,
			allContracts: [],
			expandedRows: {},
			allExpanded: false,
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null, // catching api error message
			selectedContract: null,
			selectedSociety: null,
			showBudgetPopup: false,
			showConfirmationPopup: false,
			showOrderTable: true,
			showContractPopup: false,
			tableRefreshKey: 0,
			od: [],
			showDocPopup: false,
			allOrders: [],
			showNotepadPopup: false,
			showHistoryPopup: false,
			showLinkPopup: false,
			showLinkEditPopup: false,
			showNewPurchasePopup: false,
			showSocietyPopup: false,
			tmpContractId: null,
			refreshOrderTableKey: 0,
			modifiedNetlink: Netlink.getFormFields(),
			validators: [],
			anchorTypes: [
				{ text: "Brand et Générique", value: 0 },
				{ text: " Semi optimisée", value: 1 },
				{ text: "Générique", value: 2 },
				{ text: "Non optimisée", value: 3 },
				{ text: "Optimisée", value: 4 },
			],
			netlinkStatus: [
				{ text: "Actif", value: 0 },
				{ text: "En\u00a0attente", value: 1 },
				{ text: "Refusé", value: 2 },
				{ text: "Terminé", value: 3 },
				{ text: "En\u00a0cours\u00a0de\u00a0rédaction", value: 4 },
				{ text: "Annulé", value: 5 },
			],
			//DocPopup
			societyId: null,
			societyName: null,
			contractId: null,
			productName: null,
			missionId: null,
			taskId: null,

			showValidationPopup: false,
			contractToDelete: null,
			showModal: false,
			allDocuments: [],
			// Google ads
			googleAds: [],
			googleAdsKey: 0,
			isLoadingGoogleAds: true,
		};
	},
	beforeCreate() {
		this.$store.dispatch("getAllTasks");
		this.$store.dispatch("getAllContractsWithContractsUsers");
		this.$store.dispatch("getAllNetlinkTypes");
		this.$store.dispatch("getAllCollaboratorsAvatar");
		this.$store.dispatch("getAllProviders");
		this.$store.dispatch("getAllServices");
		this.$store.dispatch("getAllSocieties");

		this.$store.dispatch("getAllProductsCategories");
		this.$emit("getData");
	},
	created() {
		this.$store.dispatch("getAllOrders");
		this.fetchGoogleAds();
		this.od = this.all_orders;
	},
	updated() {
		// this.expandAll();
	},
	mounted() {
		store.dispatch(
			"updateTableHeight",
			this.windowHeigth -
				this.horizentalNavBarHeight -
				this.filterCardHeight -
				0.2 * this.windowHeigth
		);
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				store.dispatch(
					"updateTableHeight",
					this.windowHeigth -
						this.horizentalNavBarHeight -
						this.filterCardHeight -
						0.2 * this.windowHeigth
				);
			});
		});
	},
	watch: {
		all_orders: function (data) {
			this.od = data;
			this.refreshOrderTableKey++;
		},
		isLoading: function (data) {
			if (data) {
				this.$vs.loading({
					container: "#div-with-loading",
					scale: 0.6,
				});
			} else {
				this.$vs.loading.close("#div-with-loading > .con-vs-loading");
			}
		},
		isFilterDown: function () {
			store.dispatch(
				"updateFilterCardHeight",
				document.getElementById("fliterCard").clientHeight
			);
			store.dispatch(
				"updateTableHeight",
				this.windowHeigth -
					this.horizentalNavBarHeight -
					this.filterCardHeight -
					0.2 * this.windowHeigth
			);
		},
		contracts: function (data) {
			let tmp = JSON.parse(JSON.stringify(data));
			for (let c of tmp) {
				// Mission.getMissionsForContract(c.contract_id, (err, res) => {
				// 	try {
				// 		let missions = Object.entries(res);
				// 		for (let m of c.missions_list) {
				// 			m["product_number"] =
				// 				parseInt(
				// 					missions.find((mission) => mission[1].id == m.mission_id)
				// 				) + 1;
				// 		}
				// 		// filtering if all done here because it was not poossible in main file
				// 		if (this.$props.isDoneFilter) {
				// 			c.missions_list = c.missions_list.filter(
				// 				(mission) => mission.task_archived == 0
				// 			);
				// 		}
				// 	} catch (e) {
				// 		console.error(e);
				// 	}
				// });
			}
			this.allContracts = tmp;
		},
		allContracts: function (data) {
			if (data.length == 0) {
				this.rowNum = 0;
			}
		},
	},
	methods: {
		openFlexiblePopup(contractId, leadConsultantId) {
			this.$store.commit("TOGGLE_FLEXIBLE_POPUP", {
				active: true,
				contractId: contractId,
				leadConsultantId: leadConsultantId,
			});
		},
		toggleExpand(index) {
			this.$set(this.expandedRows, index, !this.expandedRows[index]);
		},
		toggleAllExpand() {
			this.allExpanded = !this.allExpanded;
			const newExpandedRows = {};
			if (this.allExpanded) {
				// Expand all rows
				for (let i = 0; i < this.contracts.length; i++) {
					newExpandedRows[i] = true;
				}
			}
			// If collapsing all, newExpandedRows remains empty
			this.expandedRows = newExpandedRows;
		},
		toggleExpandIfNotInteractive(event, index) {
			// Check if the clicked element or its parents are interactive elements
			const interactiveElements = [
				"BUTTON",
				"INPUT",
				"SELECT",
				"TEXTAREA",
				"A",
				"VS-BUTTON",
				"VS-CHECKBOX",
			];
			let element = event.target;

			// Walk up the DOM tree to check for interactive elements
			while (element && element !== event.currentTarget) {
				if (interactiveElements.includes(element.tagName)) {
					return; // Don't expand if clicking on an interactive element
				}
				// Check for click handlers that stop propagation
				if (element.onclick || element.getAttribute("@click")) {
					return;
				}
				// Check for specific class names that indicate interactive elements
				if (
					element.classList &&
					(element.classList.contains("hvr-underline") ||
						element.classList.contains("vs-button"))
				) {
					return;
				}
				element = element.parentElement;
			}

			// If we got here, it's safe to toggle expand
			this.toggleExpand(index);
		},
		async fetchGoogleAds() {
			this.isLoadingGoogleAds = true;
			let period;
			const society_ids = this.$props.contracts.map(
				(contract) => contract.society_id
			);
			this.googleAds = await Society.fetchGoogleAds(society_ids, period);
			this.isLoadingGoogleAds = false;
			this.googleAdsKey++;
		},
		// /**
		//  * Get google ads cost by period
		//  * @param societyId
		//  * @param period
		//  */
		// getGoogleAdsCostByPeriod(societyId, date) {
		// 	if (!this.isLoadingGoogleAds) {
		// 		const thisSoc = this.googleAds.find((ads) => {
		// 			return ads.societyId == societyId;
		// 		});
		// 		const period = moment(date).format("MM/YYYY");
		// 		if (thisSoc.google_ads) {
		// 			return thisSoc.google_ads.campaigns[`${period}`].toLocaleString(
		// 				"fr-FR",
		// 				{
		// 					style: "currency",
		// 					currency: "EUR",
		// 				}
		// 			);
		// 		} else return null;
		// 	}
		// },
		// /**
		//  * Get google ads total cost
		//  * @param societyId
		//  * @param period
		//  */
		// getGoogleAdsTotalCost(societyId, date) {
		// 	if (!this.isLoadingGoogleAds) {
		// 		const thisSoc = this.googleAds.find((ads) => {
		// 			return ads.societyId == societyId;
		// 		});
		// 		const period = moment(date).format("MM/YYYY");
		// 		if (thisSoc.google_ads) {
		// 			return thisSoc.google_ads.totalCost.toLocaleString("fr-FR", {
		// 				style: "currency",
		// 				currency: "EUR",
		// 			});
		// 		} else return null;
		// 	}
		// },
		displayNotepadPopup(contract) {
			//Initialisation des données pour le popup
			this.showNotepadPopup = true;
			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(NotepadPopup);
			let notepadPopup = new ComponentClass({
				propsData: {
					contract_id: contract.contract_id,
					popupActive: this.showNotepadPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					// selectedCommercial: contract.commercial_id
					society_id: contract.society_id,
					selectedCommercial: contract.commercial_id,
				},
			});
			notepadPopup.$mount();
			this.$refs.popupContainer.appendChild(notepadPopup.$el);
			notepadPopup.$on("close-popup", (data) => {
				this.showNotepadPopup = false;
			});
		},
		displayTaskComment(contract, task) {
			//Initialisation des données pour le popup
			this.taskFacturationPopup = true;
			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(TaskFacturationCommentPopup);
			let taskCommentPopup = new ComponentClass({
				propsData: {
					contract_id: contract.contract_id,
					popupActive: this.taskFacturationPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					task: task,
				},
			});
			taskCommentPopup.$mount();
			this.$refs.popupContainer.appendChild(taskCommentPopup.$el);
			taskCommentPopup.$on("close-popup", (data) => {
				this.taskFacturationPopup = false;
			});

			taskCommentPopup.$on("update-task-comment", (updatedTask) => {
				// Find the contract index in your data array
				const contractIndex = this.$props.contracts.findIndex(
					(c) => c.contract_id === contract.contract_id
				);

				if (contractIndex !== -1) {
					// Find the task index in the contract's missions_list
					const taskIndex = this.$props.contracts[
						contractIndex
					].missions_list.findIndex((t) => t.mission_id === task.mission_id);

					if (taskIndex !== -1) {
						// Update the task in the missions_list
						this.$props.contracts[contractIndex].missions_list[taskIndex] =
							updatedTask;

						// Refresh the table by updating the refreshKey
						//this.refreshKey = Date.now();
					}
				}
			});
		},
		async refreshOrders() {
			// this.$store.dispatch("getAllOrders");
		},
		reloadOrders() {
			this.$http
				.get(this.apiUrl + "orders/all")
				.then(async (res) => {
					this.allOrders = res.data;
				})
				.catch((err) => {
					throw err;
				});
		},
		getAllOrdersForContract() {
			try {
				this.$http
					.get(
						this.apiUrl
							? this.apiUrl + "orders/get/contract/" + this.$props.contract.id
							: store.state.backendApiUrl +
									"orders/get/contract/" +
									this.$props.contract.id
					)
					.then((res) => {
						if (res.data.length > 0) {
							store.dispatch("setAllUserCommandes", { allOrders: res.data });
							this.allOrders = store.getters.getAllCommandes;
						} else {
							this.allOrders = [];
						}
					})
					.catch((error) => {
						//console.log(error);
					});
			} catch (e) {
				console.error(e);
			}
		},
		setRowNum(len) {
			store.dispatch("setRowNum", len);
		},
		getOrderContract(id) {
			//if(!id) return [];
			let thisOrders = this.all_orders.filter(
				(ele) => ele.contract_id == id && [1, 2].includes(ele.status)
			);
			// this.showOrderTable = thisOrders.length == 0? false: true;
			return thisOrders;
		},
		// expandAll() {
		// 	let th = document.querySelector("th.td-check");
		// 	if (th.innerHTML == "<!---->") {
		// 		th.innerHTML =
		// 			'<button id="expandAll" class="extrue"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>';
		// 		th.addEventListener("click", () => {
		// 			if (
		// 				th.innerHTML ==
		// 				'<button id="expandAll" class="extrue"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>'
		// 			) {
		// 				for (let line of this.$refs.switch) {
		// 					if (!line.expanded) line.$el.click();
		// 				}
		// 				th.innerHTML =
		// 					'<button id="expandAll" class="exfalse"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>';
		// 			} else {
		// 				for (let line of this.$refs.switch) {
		// 					if (line.expanded) line.$el.click();
		// 				}
		// 				th.innerHTML =
		// 					'<button id="expandAll" class="extrue"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>';
		// 			}
		// 		});

		// 		for (let line of this.$refs.switch) {
		// 			line.$el.addEventListener("click", () => {
		// 				if (
		// 					line.expanded &&
		// 					th.innerHTML ==
		// 						'<button id="expandAll" class="extrue"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>'
		// 				) {
		// 					th.innerHTML =
		// 						'<button id="expandAll" class="exfalse"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>';
		// 				}
		// 				if (
		// 					!line.expanded &&
		// 					th.innerHTML ==
		// 						'<button id="expandAll" class="exfalse"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>'
		// 				) {
		// 					th.innerHTML =
		// 						'<button id="expandAll" class="extrue"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>';
		// 				}
		// 			});
		// 		}
		// 	}
		// },
		accept() {
			this.deleteDoc(this.docId);
			this.showConfirmationPopup = false;
		},
		validateOne(val, name) {
			let value = val;
			value == 0 ? (value = "0") : "";
			let constname = "";
			switch (name) {
				case "price":
					value ? (value = String(val)) : "";
					constname = "priceConstraint";
					break;
				case "url_bought":
				case "landing_page":
					constname = "websiteConstraint";
					break;
				default:
					value ? (value = String(val)) : "";
					value == null ? (value = "") : "";
					constname = "isNumberConstraint";
					break;
			}
			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);
			val == null ? this.validators[name].valid == false : "";
			this.validators[name].valid == false &&
			this.validators[name].errText == ""
				? (this.validators[name].errText = "Ce champ ne peut être vide.")
				: "";
			this.validators[name].valid == false &&
			this.validators[name].errText !== ""
				? (this.check = false)
				: "";
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].valid == false &&
				this.validators[name].errText !== ""
			) {
				return "display: inline-block; border: 1px solid red !important; border-radius: 5px; width: calc(100% - 30px) !important;";
			} else if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].errText == ""
			) {
				return "display: inline-block; border: 1px solid green !important; border-radius: 5px;";
			} else {
				return "display: inline-block; border: none !important; border-radius: none;";
			}
		},

		saveModifiedNetlink() {
			this.check = true;
			let fields = [
				"url_bought",
				"landing_page",
				"status",
				"anchor_type",
				"link_type",
				"price",
				"renew_duration",
			];
			let constname = "";

			for (let i = 0; i < fields.length; i++) {
				let value = this.modifiedNetlink[fields[i]];
				value == 0 ? (value = "0") : "";
				switch (fields[i]) {
					case "url_bought":
					case "landing_page":
						constname = "websiteConstraint";
						break;
					case "price":
						value ? (value = String(value)) : "";
						constname = "priceConstraint";
						break;
					default:
						value ? (value = String(value)) : "";
						value == null ? (value = "") : "";
						constname = "isNumberConstraint";
						break;
				}
				this.validators[fields[i]] = new Validator({
					constraintName: constname,
				});
				this.validators[fields[i]].check(value);
				this.modifiedNetlink[fields[i]] == null
					? (this.validators[fields[i]].valid = false)
					: "";
				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText == ""
					? (this.validators[fields[i]].errText = "Ce champ ne peut être vide.")
					: "";
				if (
					fields[i] == "renew_duration" &&
					!this.isRecurringLink(this.modifiedNetlink.link_type)
				) {
					this.modifiedNetlink.renew_duration = null;
					this.validators[fields[i]].valid = true;
				}
				if (this.isFromNDD == 1) {
					if (
						fields[i] == "renew_duration" ||
						fields[i] == "link_type" ||
						fields[i] == "price"
					) {
						this.modifiedNetlink.renew_duration = null;
						this.modifiedNetlink.link_type = null;
						this.modifiedNetlink.price = null;
						this.validators[fields[i]].valid = true;
					}
				}
				if (this.isFromNDD == 0) {
					if (fields[i] == "newNetlinkDns") {
						this.newNetlinkDns = null;
						this.validators[fields[i]].valid = true;
					}
				}
				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText !== ""
					? (this.check = false)
					: "";
			}

			this.$forceUpdate();

			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				this.modifiedNetlink.price = String(this.modifiedNetlink.price).replace(
					",",
					"."
				);
				this.modifiedNetlink.price = Number(this.modifiedNetlink.price);

				let re = new RegExp("([T|Z])", "g");
				this.modifiedNetlink.creation_date =
					this.modifiedNetlink.creation_date.replace(re, " ");

				let params = {
					id: this.modifiedNetlink.id,
					urlBought: this.modifiedNetlink.url_bought,
					anchorType: this.modifiedNetlink.anchor_type,
					landingPage: this.modifiedNetlink.landing_page,
					status: this.modifiedNetlink.status,
					linkType: this.modifiedNetlink.link_type,
					domainAuthority: this.modifiedNetlink.domain_authority,
					pageAuthority: this.modifiedNetlink.page_authority,
					trustFlow: this.modifiedNetlink.trust_flow,
					citationFlow: this.modifiedNetlink.citation_flow,
					externalLinks: this.modifiedNetlink.external_links,
					refDomains: this.modifiedNetlink.ref_domains,
					purchase_id: this.modifiedNetlink.purchase_id,
					society_id: this.modifiedNetlink.society_id,
					creation_date: this.modifiedNetlink.creation_date,
					recurring_purchase_id: this.modifiedNetlink.recurring_purchase_id,
					dns_id: this.modifiedNetlink.dns_id,
					contract_id: this.modifiedNetlink.contract_id,
					price: this.modifiedNetlink.price,
					renew_duration: this.modifiedNetlink.renew_duration,
					renew_date: this.modifiedNetlink.renew_date,
					editMain: true,
					provider_id: this.modifiedNetlink.provider_id,
				};

				let savedModifiedNetlink = new Netlink(params);
				//console.log(savedModifiedNetlink);
				savedModifiedNetlink.update((err, res) => {
					if (err)
						if (res) {
							//console.log(err);
							this.showLinkEditPopup = false;

							this.$vs.notify({
								title: "Succès",
								text: "Netlink modifié avec succès.",
							});

							this.$refs.popupContainer.children[
								this.$refs.popupContainer.children.length - 1
							].__vue__
								.getAllLinks()
								.then(() => {
									for (let contract of this.allContracts) {
										if (
											this.modifiedNetlink.contract_id == contract.contract_id
										) {
											contract.waiting_netlink_count =
												this.$refs.popupContainer.children[
													this.$refs.popupContainer.children.length - 1
												].__vue__.list.filter(
													(link) => link.status == 1
												).length;
											this.$forceUpdate();
											break;
										}
									}
								});
						}
				});
			}
		},
		confirmation(param) {
			this.showConfirmationPopup = param[0];
			this.docId = param[1];
		},
		decline() {
			this.docId = "";
			this.showConfirmationPopup = false;
		},

		deleteDoc(docId) {
			this.$http
				.delete(this.apiUrl + "shared_document/delete/document/" + docId)
				.then(() => {
					this.$refs.shareLink.refreshList(this.task_id);
				});
		},
		displayBudgetPopup(contract) {
			this.showBudgetPopup = true;
			let year = this.selectedDate.split("/")[1];
			let month = this.selectedDate.split("/")[0];
			let ComponentClass = Vue.extend(BudgetDetailPopup);
			let budgetPopup = new ComponentClass({
				propsData: {
					popupActive: this.showBudgetPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					contractId: contract.contract_id,
					year: year,
					month: month,
					societyName: contract.society_name,
					allCollaboratorsAvatar: this.allCollaboratorsAvatar,
					netlink_types: this.netlink_types,
					services: this.services,
					societies: this.societies,
					providers: this.providers,
					isTabNetlink: false,
				},
			});

			budgetPopup.$mount();
			this.$refs.popupContainer.appendChild(budgetPopup.$el);
		},
		displayContractPopup(contract_id) {
			this.selectedContract = null;
			let foundContract = this.allContractsWithContractsUsers.findIndex(
				(row) => row.id == contract_id
			);
			if (foundContract < 0) {
				this.$vs.notify({
					title: "Erreur",
					text: "Contrat introuvable, contactez l'équipe technique.",
				});
				return false;
			}
			let account_manager_avatars = [];
			if (this.allContractsWithContractsUsers[foundContract].account_managers) {
				let contract_account_managers_names =
					this.allContractsWithContractsUsers[foundContract]
						.account_managers !== null
						? this.allContractsWithContractsUsers[
								foundContract
						  ].account_managers.split(", ")
						: [];
				let contract_account_managers = contract_account_managers_names.splice(
					0,
					contract_account_managers_names.length / 2
				);
				for (let i = 0; i < contract_account_managers.length; i++) {
					account_manager_avatars.push({
						name: contract_account_managers_names[i],
						users_id: contract_account_managers[i],
						is_lead:
							this.allContractsWithContractsUsers[foundContract].lead_am ==
							contract_account_managers[i]
								? 1
								: 0,
					});
				}
			}
			this.selectedContract =
				this.allContractsWithContractsUsers[foundContract];
			this.selectedContract.account_manager_avatars = account_manager_avatars;
			this.showContractPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(ContractInfoPopup);
			let contractPopup = new ComponentClass({
				propsData: {
					contract: this.selectedContract,
					popupActive: this.showContractPopup,
					router: this.$router,
				},
			});
			// @modify-contract="modifyContract($event)"
			contractPopup.$mount();
			contractPopup.$on("modify-contract", (contractId) => {
				this.popupActive = false;
				this.modifyContract(contractId);
			});
			contractPopup.$on("modify-missions", (contractId) => {
				this.popupActive = false;
				this.modifyMissions(contractId);
			});

			this.$refs.popupContainer.appendChild(contractPopup.$el);
		},
		displayDocPopup(contract, item) {
			this.showDocPopup == true
				? (this.showDocPopup = false)
				: (this.showDocPopup = true);

			this.societyId = contract.society_id;
			this.societyName = contract.society_name;
			this.contractId = contract.contract_id;
			this.productName = item.product_name;
			this.missionId = item.mission_id;
			this.taskId = item.task_id;

			this.showDocPopup = true;
		},

		displayBacklinksPopup(contract, item) {
			this.showBacklinksPopup = true;
			let ComponentClass = Vue.extend(BacklinksContractPopup);
			let backlinksContractPopup = new ComponentClass({
				propsData: {
					popupActive: this.showBacklinksPopup,
					contractId: contract.contract_id,
					societyName: contract.society_name,
					societyId: contract.society_id,
					mission: item,
				},
			});
			backlinksContractPopup.$mount();
			this.$refs.popupContainer.appendChild(backlinksContractPopup.$el);
		},

		displaySocietyPopup(societyId) {
			this.selectedSociety = null; // Always reset data before assigning it
			this.selectedSociety = JSON.parse(
				JSON.stringify(this.getSocietyById(societyId))
			);
			this.$http
				.get(this.apiUrl + "society/getImg/" + societyId)
				.then((image) => {
					let imgObject = null;
					if (image.data.length > 0) {
						imgObject = image.data;
					}

					this.selectedSociety.image = imgObject;
				})
				.catch((err) => {
					//console.log(err);
				});

			this.showSocietyPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(SocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.selectedSociety,
					popupActive: this.showSocietyPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},

		displayHistoryPopup(contract_id, society_id, society_name) {
			this.tmpContractId = contract_id;
			this.showHistoryPopup = true;
			//Récupération des tâches liées à la société
			let society_tasks = JSON.parse(JSON.stringify(this.tasks));
			//console.log("society_tasks", society_tasks);
			society_tasks = society_tasks.filter(
				(task) => task.contract_society_id == society_id
			);

			let ComponentClass = Vue.extend(TaskHistoryPopup);
			let historyPopup = new ComponentClass({
				propsData: {
					tasks: society_tasks,
					popupActive: this.showHistoryPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					store: this.$store,
					societyName: society_name,
					contractId: contract_id,
				},
			});
			historyPopup.$mount();
			historyPopup.$on("update:popupActive", () => {
				this.refreshTask();
			});
			this.$refs.popupContainer.appendChild(historyPopup.$el);
		},

		displayLinkPopup(contract_id, society_name) {
			this.showLinkPopup = true;

			let ComponentClass = Vue.extend(LinkPopup);
			let linkPopup = new ComponentClass({
				ref: "linkPopup",
				propsData: {
					popupActive: this.showLinkPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					contractId: contract_id,
					societyName: society_name,
				},
			});

			linkPopup.$mount();
			linkPopup.$on("modify-netlink", (event) => {
				this.updateNetlink(event);
			});
			this.$refs.popupContainer.appendChild(linkPopup.$el);
		},
		displayNewPurchasePopup(contract, missionId) {
			this.showNewPurchasePopup = true;

			let ComponentClass = Vue.extend(HistoricalPurchasesPopup);
			let newPurchasePopup = new ComponentClass({
				propsData: {
					apiUrl: this.apiUrl,
					missionId: missionId,
					popupActive: this.showNewPurchasePopup,
					contractId: contract.contract_id,
					societyId: contract.society_id,
					societyName: contract.society_name,
					societies: this.societies,
					providers: this.providers,
					services: this.services,
					products_categories: this.products_categories,
				},
			});
			newPurchasePopup.$mount();
			newPurchasePopup.$on("update:popupActive", () => {
				//this.refreshTask()
			});
			newPurchasePopup.$on("refresh-data", () => {
				this.$emit("refresh-data");
				//this.refreshTask()
			});
			this.$refs.popupContainer.appendChild(newPurchasePopup.$el);
		},
		displayNewCommandePopup(contract) {
			//  store.dispatch("toogleNewCommandePopup", true);
			this.showNewPurchasePopup = true;
			let ComponentClass = Vue.extend(NewCommandePopup);
			let newCommandePopup = new ComponentClass({
				propsData: {
					contract: contract,
					popupActive: this.showNewPurchasePopup,
					apiUrl: this.apiUrl,
					router: this.$router,
				},
			});
			newCommandePopup.$mount();
			newCommandePopup.$on("update:popupActive", () => {
				//this.refreshTask()
			});
			newCommandePopup.$on("refresh-data", () => {
				this.$emit("refresh-data");
				//this.refreshTask()
			});
			this.$refs.popupContainer.appendChild(newCommandePopup.$el);
		},

		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		getDate(date) {
			if (date) {
				let arr = {
					"01": "Janvier",
					"02": "Février",
					"03": "Mars",
					"04": "Avril",
					"05": "Mai",
					"06": "Juin",
					"07": "Juillet",
					"08": "Août",
					"09": "Septembre",
					10: "Octobre",
					11: "Novembre",
					12: "Décembre",
				};

				return arr[date.substr(5, 2)] + " " + date.substr(0, 4);
			} else {
				return "One Shot";
			}
		},

		getLineColor(total, done) {
			if (total - done == 0) return "background: #edfff9;";
			else return "background: #f8f8f8;";
		},

		getSocietyById(societyId) {
			return this.societies.find((society) => society.id == societyId);
		},

		isRecurringLink(link_type) {
			let foundIndex = this.netlink_types.findIndex(
				(row) => row.id == link_type
			);
			if (foundIndex >= 0) {
				if (this.netlink_types[foundIndex].recurrency == 1) return true;
			}
			return false;
		},

		jumpToKeyword(id) {
			let link = this.$router.resolve({
				name: "keyword",
				query: {
					targetSociety: id,
				},
			});
			window.open(link.href, "_blank");
		},

		modifyContract(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 0,
					updateEntityForm: "contracts",
				},
			});
		},

		modifyMissions(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 1,
					updateEntityForm: "contracts_missions",
				},
			});
		},

		async refreshTask() {
			for (let contract of this.allContracts) {
				if (contract.contract_id == this.tmpContractId) {
					for (let i of contract.missions_list) {
						await this.$http
							.get(this.apiUrl + "task/get/" + i.task_id)
							.then((result) => {
								let task = result.data;
								if (i.task_archived == 1 && task.archivate !== 1)
									contract.tasks_done--;
								else if (i.task_archived !== 1 && task.archivate == 1)
									contract.tasks_done++;
								i.task_archived = task.archivate;
							})
							.catch((err) => {
								//console.log(err);
							});
					}
					this.$forceUpdate();
					this.tmpContractId = null;
					break;
				}
			}
		},

		setBudgetColor(budget) {
			if (budget.length == 2 && budget[0] > 0 && budget[1] > 0) {
				if (budget[1] / budget[0] > 1) return "color: red;";
				if (budget[1] / budget[0] <= 1 && budget[1] / budget[0] >= 0.85)
					return "color: green;";
				if (budget[1] / budget[0] < 0.85) return "color: orange;";
			}
		},

		setSolde(solde) {
			if (solde) {
				if (solde > 0) return "+" + Math.round(solde * 100) / 100 + "€";
				else if (solde < 0) return Math.round(solde * 100) / 100 + "€";
				else return "0€";
			} else return null;
		},

		setSoldeColor(solde) {
			if (solde) {
				if (solde > 0) return "color: green;";
				else if (solde < 0) return "color: red;";
				else return null;
			} else return null;
		},

		updateNetlink(netlink) {
			this.modifiedNetlink = null; // Always reset data before assigning it
			this.modifiedNetlink = JSON.parse(JSON.stringify(netlink));
			this.showLinkEditPopup = true;
		},

		async updateTask(taskinfo, task_state, contract) {
			let today = new Date(Date.now());
			today = today.toISOString();

			let re = new RegExp("([T|Z])", "g");
			let creation_date = taskinfo.task_date
				? taskinfo.task_date.replace(re, " ")
				: null;
			today = today.replace(re, " ");
			let finished_date = taskinfo.task_archived ? today : null;
			// conso;
			await this.$http
				.get(this.apiUrl + "task/get/" + taskinfo.task_id)
				.then((result) => {
					let task = result.data;
					this.$http
						.post(this.apiUrl + "task/edit/" + task.id, {
							commentary: task.commentary,
							link: task.link,
							status: task.status,
							creation_date: creation_date,
							finished_date: finished_date,
							recurrence: task.recurrence,
							frequency: task.frequency,
							archivate: task_state,
							contract_id: task.contract_id,
							contract_society_id: task.contract_society_id,
							mission_id: task.mission_id,
						})
						.then((res) => {
							//console.log("resTask", res);
							if (!task.recurrence || task.recurrence == 0) {
								let mission_status = 1;
								if (task_state == 1) {
									mission_status = 7;
								} else if (task_state == 0 || task_state == 2) {
									mission_status = 1;
								}
								this.$http
									.post(this.apiUrl + "mission/editarch", {
										contract_id: task.contract_id,
										status: mission_status,
										id: task.mission_id,
									})
									.then((res) => {
										//console.log("resMission", res);
										this.$vs.notify({
											title: "Succès",
											text: "Tâche modifiée avec succès.",
										});
										store.dispatch("getAllTasks");
										this.$emit("refresh-task");
									})
									.catch((err) => {
										console.log(err);
										this.$vs.notify({
											title: "Echec",
											text: "La tâche n'a pas été modifiée.",
										});
									});
							} else {
								this.$vs.notify({
									title: "Succès",
									text: "Tâche modifiée avec succès.",
								});
								this.$emit("update-task", [task, task_state]);
								store.dispatch("getAllTasks");
							}
							if (taskinfo.task_archived == 1 && task_state !== 1)
								contract.tasks_done--;
							else if (taskinfo.task_archived !== 1 && task_state == 1)
								contract.tasks_done++;
							else if (taskinfo.task_archived !== 2 && task_state == 2) {
								contract.total_tasks--;
								// this.allContracts[
								// 	this.allContracts.indexOf(contract)
								// ].missions_list.splice(
								// 	this.allContracts[
								// 		this.allContracts.indexOf(contract)
								// 	].missions_list.indexOf(taskinfo),
								// 	1
								// );
								if (taskinfo.task_archived == 1) contract.tasks_done--;
							}
							taskinfo.task_archived = task_state;

							this.$forceUpdate();
						})
						.catch((err) => {
							console.log(err);
							this.$vs.notify({
								title: "Echec",
								text: "La tâche n'a pas été ajoutée.",
							});
						});
				});
		},
	},
};
</script>

<style >
.center {
	justify-content: center;
}
.hvr-underline:hover {
	color: aqua;
	text-decoration: underline;
	cursor: pointer;
}

th > div > div,
th > div > span {
	text-transform: uppercase;
}

.th-sticky {
	position: sticky;
	top: 0;
	background-color: inherit;
}

.vs-con-tbody.vs-table--tbody {
	height: 100%;
}
.vs-tooltip.vs-tooltip-top.vs-tooltip-null {
	word-break: break-all;
}

.vs-table--thead {
	z-index: 500;
}

th.td-check {
	position: sticky;
	top: 0;
	background-color: inherit;
	pointer-events: auto;
}
#expandAll {
	border: none;
	pointer-events: auto;
	cursor: pointer;
}
.extrue {
	padding-top: 20px;
	padding-right: 10px;
	background: none;
	transform: rotate(-90deg);
}

.exfalse {
	padding-left: 5px;
	background: none;
	transform: rotate(0deg);
}

.content-tr-expand > div > div > div > div > table > thead > tr {
	background: #0c293d;
}
.content-tr-expand > div > div > div > div > table > thead > tr > th > div {
	color: white;
}

.expand-row td {
	background-color: #ffffffff;
	padding: 20px !important;
}

.expand-icon-wrapper:hover {
	background-color: rgba(0, 0, 0, 0.05);
	border-radius: 4px;
}
</style>
